import { createAsyncThunk } from '@reduxjs/toolkit'
import { ActeurAction, UserActionResponse } from '../../types/actorActionTypes'
import {
  createActeurAction,
  getActeursByActionId,
  getMyActions,
  updateActorAction,
} from '../../api/actorActionApi'
import { handleError } from '../../utils/errorHandler'

export const createActeurActionAsync = createAsyncThunk<
  ActeurAction,
  { ActionId: string; RASCI: Record<string, string[]> },
  { rejectValue: string }
>('acteurAction/createActeurAction', async ({ ActionId, RASCI }, thunkAPI) => {
  try {
    const response = await createActeurAction({ ActionId, RASCI })
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const fetchActeursByActionId = createAsyncThunk<
  any,
  string,
  { rejectValue: string }
>('acteurAction/fetchByActionId', async (actionId, thunkAPI) => {
  try {
    const response = await getActeursByActionId(actionId)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const updateActeurActionAsync = createAsyncThunk<
  any,
  { actorId: string; actionId: string; RASCI: any },
  { rejectValue: string }
>(
  'acteurAction/updateByActionId',
  async ({ actorId, actionId, RASCI }, thunkAPI) => {
    try {
      const response = await updateActorAction(actorId, { actionId, RASCI })
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)

export const fetchMyActions = createAsyncThunk<
  UserActionResponse,
  void,
  { rejectValue: string }
>('actions/fetchMyActions', async (_, thunkAPI) => {
  try {
    return await getMyActions()
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
